import consumer from "./consumer"

// Global variable to store the subscription
window.choreAssignmentsSubscription = null;
window.choreAssignmentsParams = null;

// Function to subscribe to the channel for a specific household and month
window.subscribeToChoreAssignments = function(householdId, month) {
  // Store parameters for reconnection
  window.choreAssignmentsParams = { householdId, month };

  // Unsubscribe from existing subscription if any
  if (window.choreAssignmentsSubscription) {
    consumer.subscriptions.remove(window.choreAssignmentsSubscription);
  }

  // Create new subscription for the current household and month
  window.choreAssignmentsSubscription = consumer.subscriptions.create(
    { channel: "ChoreAssignmentsChannel", household_id: householdId, month: month },
    {
      connected() {
        console.log("Connected to ChoreAssignmentsChannel for household:", householdId, "month:", month);
        // Fetch latest data after reconnection to ensure sync
        if (window.wasDisconnected) {
          console.log("Refreshing data after reconnection...");
          refreshChoreData(householdId, month);
          window.wasDisconnected = false;
        }
      },

      disconnected() {
        console.log("Disconnected from ChoreAssignmentsChannel");
        window.wasDisconnected = true;
      },

      received(data) {
        console.log("Received chore assignment update:", data);
        handleChoreUpdate(data);
      }
    }
  );
};

// Function to refresh chore data after reconnection
function refreshChoreData(householdId, month) {
  const currentPath = window.location.pathname;
  const currentParams = new URLSearchParams(window.location.search);

  // Only refresh if we're on the chore assignments page
  if (currentPath.includes('chore_assignments') || currentPath === '/') {
    // Use Turbo to reload the current page, preserving the date parameter
    console.log("Reloading page to sync data...");
    Turbo.visit(window.location.href, { action: "replace" });
  }
}

// Listen for visibility changes to detect phone lock/unlock
document.addEventListener('visibilitychange', function() {
  if (!document.hidden && window.choreAssignmentsParams) {
    console.log("Page became visible, checking connection...");
    // Small delay to allow network to stabilize
    setTimeout(() => {
      if (!consumer.connection.isActive()) {
        console.log("Connection inactive, attempting to reconnect...");
        consumer.connection.open();
      }
      // Resubscribe to ensure we have the latest data
      if (window.choreAssignmentsParams) {
        const { householdId, month } = window.choreAssignmentsParams;
        window.subscribeToChoreAssignments(householdId, month);
      }
    }, 500);
  }
});

// Function to handle real-time chore updates
function handleChoreUpdate(data) {
  const { action, chore_id, date, assignment_id, user_name, user_color, user_id } = data;
  
  // Find the chore item for this specific chore and date
  const calendarDay = document.querySelector(`[data-date="${date}"]`);
  if (!calendarDay) {
    console.log("Calendar day not found for date:", date);
    return;
  }

  const choreItem = calendarDay.querySelector(`[data-chore-id="${chore_id}"]`);
  if (!choreItem) {
    console.log("Chore item not found for chore_id:", chore_id);
    return;
  }

  // Get current user ID for comparison (we'll pass this from the view)
  const currentUserId = window.currentUserId;

  if (action === 'assigned') {
    // Update the chore item to show it's assigned
    choreItem.classList.remove('available');
    choreItem.classList.add('assigned');
    choreItem.dataset.assignmentId = assignment_id;
    const isCurrentUser = (user_id == currentUserId);
    choreItem.dataset.assignedToCurrentUser = isCurrentUser ? 'true' : 'false';
    choreItem.dataset.userColor = user_color;

    // Update can-unassign based on whether current user is admin (passed from server)
    const isAdmin = window.currentUserIsAdmin;
    choreItem.dataset.canUnassign = (isCurrentUser || isAdmin) ? 'true' : 'false';

    // Apply user color to background and border with !important
    if (user_color) {
      choreItem.style.setProperty('background-color', user_color, 'important');
      choreItem.style.setProperty('border-color', user_color, 'important');
    }

    const statusSpan = choreItem.querySelector('.assignment-status');
    statusSpan.innerHTML = `<span class="user-name">${user_name}</span>`;

    // Add a brief animation to indicate the change
    choreItem.classList.add('changing');
    setTimeout(() => {
      choreItem.classList.remove('changing');
    }, 500);

  } else if (action === 'unassigned') {
    // Update the chore item to show it's available
    choreItem.classList.remove('assigned');
    choreItem.classList.add('available');
    choreItem.dataset.assignmentId = '';
    choreItem.dataset.assignedToCurrentUser = 'false';
    choreItem.dataset.canUnassign = 'false';
    choreItem.dataset.userColor = '';

    // Reset background and border
    choreItem.style.backgroundColor = '';
    choreItem.style.borderColor = '';

    const statusSpan = choreItem.querySelector('.assignment-status');
    statusSpan.innerHTML = '<span class="available-text">Available</span>';

    // Add a brief animation to indicate the change
    choreItem.classList.add('changing');
    setTimeout(() => {
      choreItem.classList.remove('changing');
    }, 500);

  } else if (action === 'completed') {
    // Mark the chore as completed
    choreItem.classList.add('completed');
    choreItem.dataset.completed = 'true';

    // Add checkmark if not already present
    const statusSpan = choreItem.querySelector('.assignment-status');
    if (!statusSpan.querySelector('.completion-checkmark')) {
      const checkmark = document.createElement('span');
      checkmark.className = 'completion-checkmark';
      checkmark.textContent = '✓';
      statusSpan.appendChild(checkmark);
    }

    // Add animation
    choreItem.classList.add('changing');
    setTimeout(() => {
      choreItem.classList.remove('changing');
    }, 500);

  } else if (action === 'uncompleted') {
    // Mark the chore as uncompleted
    choreItem.classList.remove('completed');
    choreItem.dataset.completed = 'false';

    // Remove checkmark
    const checkmark = choreItem.querySelector('.completion-checkmark');
    if (checkmark) {
      checkmark.remove();
    }

    // Add animation
    choreItem.classList.add('changing');
    setTimeout(() => {
      choreItem.classList.remove('changing');
    }, 500);
  }
}
